import { SearchForSuggestionsResult } from 'aws-sdk/clients/location';

export function isSuggestionStreetAddress(
  suggestion: SearchForSuggestionsResult
): boolean {
  let parts = suggestion.Text.split(',');
  if (parts.length < 4) {
    return false;
  }
  return true;
}
